export default "__VITE_ASSET__DDRqhXjZ__"